// Light theme configuration
export const lightTheme = {
  colors: {
    background: '#f8f9fa',
    backgroundAlt: '#ffffff',
    backgroundCard: '#ffffff',
    textPrimary: 'rgba(0,0,0,0.92)',
    textSecondary: 'rgba(0,0,0,0.65)',
    textTertiary: 'rgba(0,0,0,0.45)',
    borderSoft: 'rgba(0,0,0,0.08)',
    borderStrong: 'rgba(0,0,0,0.15)',
    glass: 'rgba(0,0,0,0.02)',
    // Brand accents (purple palette - adjusted for light mode)
    brandPrimary: '#8B3FD9',
    brandAccent: '#A259FF',
    brandText: '#6B2FB8',
    brandBgStart: '#f5f0ff',
    brandBgEnd: '#e8daff',
    // Status colors
    positive: '#16a34a',
    negative: '#dc2626',
    warning: '#d97706',
    info: '#2563eb',
    // Interactive states
    hover: 'rgba(139, 63, 217, 0.08)',
    active: 'rgba(139, 63, 217, 0.15)',
    selected: 'rgba(139, 63, 217, 0.12)',
  },
  shadows: {
    card: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.06,
      shadowRadius: 12,
      elevation: 2,
    },
    cardHover: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.1,
      shadowRadius: 16,
      elevation: 4,
    },
    cardSelected: {
      shadowColor: '#8B3FD9',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 16,
      elevation: 4,
    }
  }
};

// Dark theme configuration (existing + enhanced)
export const darkTheme = {
  colors: {
    background: '#0b0b0b',
    backgroundAlt: '#131313',
    backgroundCard: '#1a1a1a',
    textPrimary: 'rgba(255,255,255,0.92)',
    textSecondary: 'rgba(255,255,255,0.7)',
    textTertiary: 'rgba(255,255,255,0.5)',
    borderSoft: 'rgba(255,255,255,0.12)',
    borderStrong: 'rgba(255,255,255,0.24)',
    glass: 'rgba(255,255,255,0.06)',
    // Brand accents (purple palette)
    brandPrimary: '#A259FF',
    brandAccent: '#E0BBFF',
    brandText: '#EBDEFF',
    brandBgStart: '#000000',
    brandBgEnd: '#291B32',
    // Status colors
    positive: '#4ade80',
    negative: '#f87171',
    warning: '#fbbf24',
    info: '#60a5fa',
    // Interactive states
    hover: 'rgba(162, 89, 255, 0.08)',
    active: 'rgba(162, 89, 255, 0.15)',
    selected: 'rgba(162, 89, 255, 0.12)',
  },
  shadows: {
    card: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.3,
      shadowRadius: 12,
      elevation: 4,
    },
    cardHover: {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.4,
      shadowRadius: 16,
      elevation: 6,
    },
    cardSelected: {
      shadowColor: '#A259FF',
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.5,
      shadowRadius: 20,
      elevation: 8,
    }
  }
};

